import React, {createContext, useContext, useState, useEffect} from "react";

const MetronicSplashScreenContext = createContext();

export function MetronicSplashScreenProvider({ children }) {
  const [count, setCount] = useState(0);
  let visible = count > 0;

  useEffect(() => {
    const splashScreen = document.getElementById("splash-screen");

    if (!splashScreen) {
      return;
    }

    // Show SplashScreen
    if (visible) {
      splashScreen.classList.remove("hidden");
    } else {
      // Hide SplashScreen with delay
      const timeout = setTimeout(() => {
        splashScreen.classList.add("hidden");
      }, 500);

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [visible]);

  return (
    <MetronicSplashScreenContext.Provider value={setCount}>
      {children}
    </MetronicSplashScreenContext.Provider>
  );
}

export function LayoutSplashScreen({ visible = true }) {
  const setCount = useContext(MetronicSplashScreenContext);

  useEffect(() => {
    if (!visible) {
      return;
    }

    setCount(prev => prev + 1);

    return () => {
      setCount(prev => prev - 1);
    };
  }, [setCount, visible]);

  return null;
}